import { IEditModePayload, IGetModeList, IModeCreate, IModeDetails, IModeListSearch } from "../../../types/master/modeInterface";
import { ModeActionTypes, ModeActions } from "../../actionTypes/master/modeActionTypes";

export const getModeList = (payload: IModeListSearch): ModeActionTypes => ({
  type: ModeActions.GET_MODE_LIST,
  payload,
});
export const setModeList = (modeList: Array<IGetModeList>): ModeActionTypes => ({
  type: ModeActions.SET_MODE_LIST,
  payload: modeList,
});
export const setModeListPageCount = (payload: number): ModeActionTypes => ({
  type: ModeActions.SET_MODE_LIST_PAGE_COUNT,
  payload,
});
export const createMode = (mode: IModeCreate): ModeActionTypes => ({
  type: ModeActions.CREATE_MODE,
  payload: mode,
});
export const getModeDataById = (id: number): ModeActionTypes => ({
  type: ModeActions.GET_MODE_DATA_BY_ID,
  payload: id,
});
export const setModeDataById = (payload: IModeDetails) => ({
  type: ModeActions.SET_MODE_DATA_BY_ID,
  payload,
});
export const editMode = (payload: IEditModePayload) => ({
  type: ModeActions.EDIT_MODE_DATA_BY_ID,
  payload,
});
